/**
 * Flag Codes Portal API client.
 *
 * Backed by /api/v1/data-vault/flag-codes/* on argos-data-vault.
 * Each tenant owns their own flag-code list — see backend
 * src/products/data_vault/flag_codes_routes.py.
 */
import { apiClient } from './client';

export type FlagCodeCategory = 'gauging' | 'analytical';

export interface FlagCode {
  id: string;
  code: string;
  description: string;
  category: FlagCodeCategory;
  is_active: boolean;
}

export interface CreateFlagCodeBody {
  code: string;
  description: string;
  category: FlagCodeCategory;
  is_active?: boolean;
}

export interface UpdateFlagCodeBody {
  code?: string;
  description?: string;
  category?: FlagCodeCategory;
  is_active?: boolean;
}

export const flagCodesApi = {
  list: (category?: FlagCodeCategory) => {
    const params: Record<string, string> = {};
    if (category) params.category = category;
    return apiClient
      .get<FlagCode[]>('/data-vault/flag-codes', { params })
      .then((r) => r.data);
  },

  create: (body: CreateFlagCodeBody) =>
    apiClient
      .post<FlagCode>('/data-vault/flag-codes', body)
      .then((r) => r.data),

  update: (id: string, body: UpdateFlagCodeBody) =>
    apiClient
      .put<FlagCode>(`/data-vault/flag-codes/${id}`, body)
      .then((r) => r.data),

  delete: (id: string) =>
    apiClient
      .delete(`/data-vault/flag-codes/${id}`)
      .then(() => undefined),
};
